import React, { FC } from 'react';
//@ts-ignore
import background from '../../../assets/images/homepage_bg.png';

import { useStyles } from './styles';

export interface BaseProps {}

export const Base: FC<BaseProps> = ({ children }) => {
  const classes = useStyles();
  return (
    <div className='bg-brand_primary min-h-screen'>
      <div className={classes.content+" min-h-screen"}>{children}</div>
    </div>
  );
};

export default Base;
